module.exports = __webpack_public_path__ + "static/media/success.66fd4dde.gif";